import { render } from "./ElementView.vue?vue&type=template&id=1930933e"
import script from "./ElementView.vue?vue&type=script&lang=js"
export * from "./ElementView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__